import type { Theme } from "../types/Theme";
import {
    MODERN_FILE_UPLOAD_DESTRUCTIVE_COLOR,
    MODERN_FILE_UPLOAD_FOREGROUND_COLOR,
} from "./fileUploadThemeTokens";
import { shouldUseModernTheme } from "./navigationButtonThemeColors";

export const MODERN_TIMER_LABEL_FONT_WEIGHT = 600;
export const MODERN_TIMER_READOUT_FONT_WEIGHT = 600;
export const MODERN_TIMER_READOUT_SIZE_MOBILE_PX = 30;
export const MODERN_TIMER_READOUT_SIZE_DESKTOP_PX = 36;
export const MODERN_TIMER_READOUT_BREAKPOINT_PX = 640;
export const MODERN_TIMER_READOUT_MONO_FONT = "'Roboto Mono', monospace";
export const MODERN_TIMER_READOUT_LETTER_SPACING = "-0.025em";
export const MODERN_TIMER_WARN_THRESHOLD_SECONDS = 10;
export const MODERN_TIMER_PULSE_DURATION_MS = 2000;

export function useModernTimerStyles(theme: Theme): boolean {
    return shouldUseModernTheme(theme);
}

export function resolveModernTimerLabelFontSize(theme: Theme): string {
    return theme.TextFontSize || `${theme.BaseFontSize ?? 16}px`;
}

export function resolveModernTimerForegroundColor(): string {
    return MODERN_FILE_UPLOAD_FOREGROUND_COLOR;
}

export function resolveModernTimerReadoutColor(isEnding: boolean): string {
    return isEnding ? MODERN_FILE_UPLOAD_DESTRUCTIVE_COLOR : MODERN_FILE_UPLOAD_FOREGROUND_COLOR;
}

export function isModernTimerEnding(
    isCountDown: boolean,
    secondsRemaining: number | undefined,
    warnThresholdSeconds = MODERN_TIMER_WARN_THRESHOLD_SECONDS,
): boolean {
    return (
        isCountDown &&
        secondsRemaining !== undefined &&
        secondsRemaining <= warnThresholdSeconds
    );
}
